import { css } from 'styled-components';

export const btTheme = css`
    --color-primary: #1C7EFF;

    --color-state-primary: rgba(28, 126, 255, 0.07);
    --color-state-secondary: rgba(28, 126, 255, 0.24);
    --color-state-tertiary: rgba(48, 49, 48, 0.07);

    --color-outline: var(--color-primary);

    /* Home Page */
    --home-hero-background: linear-gradient(196deg, #2F2F2F 21.87%, #000 78.13%);
    --home-hero-title-color: white;
    --home-hero-subtitle-color: white;

    /* Subscription Page */
    --subscription-hero-background: #E8F2FF;
    --subscription-hero-title-color: black;
    --subscription-hero-subtitle-color: black;

    /* User Shortcuts */
    --color-outline-accent: var(--color-primary);
`;
